import notDeleted from '../../notDeleted'
import { definitionCollection } from '../../../firebase/publicDefinitions';

const getMatrixRowDefs = async (fieldId, db, rowDefsCache) => {
  if (rowDefsCache.has(fieldId)) return rowDefsCache.get(fieldId)
  const rowSnap = await definitionCollection('MatrixQuestionRows', db).where('Field', '==', fieldId).get()
  // Zacht verwijderde rijen weg, net als op de server (calculateCompanyGrowth, msiResearchData).
  // AI-CONTEXT: See docs/pitfalls.md#database-hard-to-soft-delete-leaves-old-orphans
  const defs = rowSnap.docs.map(d => d.data()).filter(notDeleted)
  rowDefsCache.set(fieldId, defs)
  return defs
}

export default getMatrixRowDefs;